export default "__VITE_ASSET__d9c211f6__"